//libs
import React, { useCallback } from 'react';
import c from 'classnames';
import { TextSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

//components
import { Ellipse } from '@lyearn/icons';
import { Box, PopperProps, Stack } from '@lyearn/ui';

//consts
import {
  CalloutBlockCategory,
  CalloutBlocks,
  calloutBlocksByKey,
  CalloutBlockTypeEnum,
} from '../../../../nodes/Callout/consts';
import { getElementPos, setNodeAttrs } from '../../../../utils';
import { getTooltipAnchorEl } from '../../utils';
//styles
import { setBackground, setColor } from './styles';

interface CalloutTypesProps {
  view: EditorView;
}

const CalloutTypes: React.FC<CalloutTypesProps> = (props) => {
  const { view } = props;

  const onAction = useCallback(
    (calloutType: CalloutBlockTypeEnum) => {
      if (!view) {
        return;
      }
      const currentSelectionNode = (view.state.selection as TextSelection).$from.parent;
      const currentPos = view.state.selection.$from.pos;
      const parentPos = view.domAtPos(currentPos).node.parentElement;
      if (!parentPos) {
        return;
      }
      const calloutEl = getTooltipAnchorEl(parentPos) as PopperProps['anchorEl'];
      const pos = getElementPos(calloutEl, view);
      if (calloutBlocksByKey[calloutType] && pos) {
        setNodeAttrs(view, pos.inside, {
          ...currentSelectionNode?.attrs,
          type: calloutType,
        });
      }
    },
    [view],
  );

  const onClick = useCallback(
    (event: any) => {
      const calloutType = event.currentTarget.getAttribute(
        'data-callout-type',
      ) as CalloutBlockTypeEnum;
      onAction(calloutType);
    },
    [onAction],
  );

  return (
    <Stack alignItems="center" className="p-6 pe-2">
      {CalloutBlocks.map((calloutType) => (
        <Box
          key={calloutType.id}
          className="cursor-pointer rounded-4 p-4 me-4 hover:bg-interactive-white-hover"
          data-callout-type={calloutType.id}
          role="button"
          onClick={onClick}>
          {calloutType.category === CalloutBlockCategory.Light ? (
            <Ellipse className={c('h-20 w-20', setColor(calloutType.iconColor))} />
          ) : (
            <Box className={c('h-20 w-20 rounded-full', setBackground(calloutType.background))} />
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default CalloutTypes;
